import { createFileRoute, redirect, type SearchSchemaInput } from '@tanstack/react-router';
import { sessionQuery } from '@/services/session';
import { myInvitesQuery } from '@/services/invites';
import { parseInviteId } from '@/features/join/join-model';
import { JoinPage } from '@/features/join/join-page';

export const Route = createFileRoute('/join')({
  // A plain validator, not zod: everything outside the loader and the component sits in the entry.
  validateSearch: (search: { invite?: string | number } & SearchSchemaInput): { invite?: number } => {
    const invite = parseInviteId(search.invite);
    return invite ? { invite } : {};
  },
  // Signed out? Sign in, then come back to this invite.
  beforeLoad: async ({ context: { queryClient }, location }) => {
    const user = await queryClient.ensureQueryData(sessionQuery).catch(() => null);
    if (!user) throw redirect({ to: '/auth/signin', search: { returnTo: location.href } });
  },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(myInvitesQuery).catch(() => null),
  component: JoinRoute,
});

function JoinRoute() {
  const { invite } = Route.useSearch();
  return <JoinPage inviteId={invite ?? null} />;
}
